/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolForkliftIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-forklift"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.55 21.57Q2.17 21.57 1.2 20.6Q0.23 19.63 0.23 18.25Q0.23 17.7 0.4 17.19Q0.57 16.68 0.9 16.25L0.9 11.5Q0.9 10.95 1.29 10.56Q1.68 10.18 2.23 10.18L3.23 10.18L3.23 5.75Q3.23 5.2 3.61 4.81Q4 4.42 4.55 4.42L10.03 4.42Q10.82 4.42 11.47 4.88Q12.13 5.33 12.45 6.05L16.68 15.97Q16.88 16.4 17 16.84Q17.13 17.27 17.13 17.75Q17.13 19.32 16 20.45Q14.88 21.57 13.3 21.57Q12.25 21.57 11.34 21.04Q10.43 20.5 9.93 19.57L6.6 19.57Q6.2 20.48 5.38 21.02Q4.55 21.57 3.55 21.57ZM22.48 20.57L19.48 20.57Q18.93 20.57 18.54 20.19Q18.15 19.8 18.15 19.25L18.15 4.75Q18.15 4.2 18.54 3.81Q18.93 3.42 19.48 3.42Q20.02 3.42 20.41 3.81Q20.8 4.2 20.8 4.75L20.8 17.93L22.48 17.93Q23.02 17.93 23.41 18.31Q23.8 18.7 23.8 19.25Q23.8 19.8 23.41 20.19Q23.02 20.57 22.48 20.57ZM3.55 18.93Q3.55 18.93 3.69 18.93Q3.83 18.93 4.03 18.73Q4.22 18.52 4.22 18.25Q4.22 17.98 4.03 17.77Q3.83 17.57 3.55 17.57Q3.27 17.57 3.08 17.77Q2.88 17.98 2.88 18.25Q2.88 18.52 3.08 18.73Q3.27 18.93 3.55 18.93ZM13.3 18.93Q13.3 18.93 13.55 18.93Q13.8 18.93 14.14 18.59Q14.47 18.25 14.47 17.75Q14.47 17.25 14.14 16.91Q13.8 16.57 13.3 16.57Q12.8 16.57 12.46 16.91Q12.13 17.25 12.13 17.75Q12.13 18.25 12.46 18.59Q12.8 18.93 13.3 18.93ZM8.6 13.18L12.63 13.18Q12.63 13.18 12.63 13.18Q12.63 13.18 12.63 13.18L10.03 7.08Q10.03 7.08 10.03 7.08Q10.03 7.08 10.03 7.08L5.88 7.08L5.88 10.38Z" fill={color} />
    </svg>
  );
}
